module.exports = __webpack_public_path__ + "static/img/google_store.fb994f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/bussiness/google_store.png
// module id = C8JB
// module chunks = 30